import { Spin } from 'antd';
import { I18n } from 'react-redux-i18n';
import styled from 'styled-components';

const Container = styled.div`
  .ant-spin-nested-loading .ant-spin-blur {
    opacity: 0.3;
  }

  .ant-spin-nested-loading > div > .ant-spin .ant-spin-text {
    top: 35%;
  }
`;

const LockedContent = ({
  children,
  locked,
  onClick
}: {
  children: string | JSX.Element | JSX.Element[];
  locked: boolean;
  onClick?: () => void | undefined;
}) => (
  <Container>
    <Spin
      spinning={locked}
      indicator={<></>} // @ts-expect-error ignore
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
      tip={
        <a
          href="mailto:commercial@wine-services.com"
          style={{ color: '#e25d34' }}
        >
          {I18n.t('dashboard.contact')}
        </a>
      }
    >
      {children}
    </Spin>
  </Container>
);

export default LockedContent;
